<template>
  <div
    :class="[
      'separator-border',
      vertical && 'separator-border--vertical',
      !vertical && 'separator-border--horizontal',
      gradient && gradientClass,
      !gradient && 'separator-border--solid',
      color && 'separator-border--color',
    ]"
    :style="
      `
        --widthValue: ${widthValue};
        --heightValue: ${heightValue};
        --colorValue: ${colorValue};
      `
    "
  ></div>
</template>

<script>
export default {
  name: 'SeparatorBorder',
  props: {
    vertical: {
      type: Boolean,
      required: false,
      default: false,
    },
    gradient: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: String,
      required: false,
      default: null,
    },
    height: {
      type: String,
      required: false,
      default: null,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    widthValue() {
      return this.width ? this.width : this.vertical ? '1px' : '100%'
    },
    heightValue() {
      return this.height ? this.height : this.vertical ? '33px' : '1px'
    },
    gradientClass() {
      return this.vertical
        ? 'separator-border--gradient-vertical'
        : 'separator-border--gradient'
    },
    colorValue() {
      return this.color ? this.color : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.separator-border {
  background: var(--glass-light-gray);
  &--vertical {
    width: var(--widthValue);
    height: var(--heightValue);
  }
  &--horizontal {
    width: var(--widthValue);
    height: var(--heightValue);
  }
  &--gradient {
    background: var(--glass-light-gray);
  }
  &--gradient-vertical {
    background: var(--glass-light-gray-vertical);
  }
  &--solid {
    background: var(--glass-solid-mid-gray);
  }
  &--color {
    background: var(--colorValue) !important;
  }
}
</style>
